import { render } from "./Seller.vue?vue&type=template&id=07f2a964&scoped=true"
import script from "./Seller.vue?vue&type=script&lang=js"
export * from "./Seller.vue?vue&type=script&lang=js"

import "@/assets/css/layout_provider.css?vue&type=style&index=0&id=07f2a964&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f2a964"]])

export default __exports__